<form [formGroup]="formGroup" id="step2Form">
  <div class="step2-form-container">
    <div class="row">
      @if (controls.telephoneNumber; as telephoneNumber) {
        <div class="standard-form-field widened-field telephoneNumber-field required-field">
          <label for="telephoneNumberInput" [class.invalid]="telephoneNumber.touched && telephoneNumber.invalid">
            {{ 'PERSONAL_DATA_FORM.TELEPHONE-NUMBER.INFIELD-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              #telephoneNumberInput
              inputmode="tel"
              type="text"
              id="telephoneNumberInput"
              placeholder="{{ 'PERSONAL_DATA_FORM.TELEPHONE-NUMBER.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="telephoneNumber.touched && telephoneNumber.invalid ? 'true' : null"
              [attr.aria-describedby]="
                telephoneNumber.touched && telephoneNumber.invalid ? 'telephoneNumberError' : null
              "
              (keydown)="firstInputKeydown($event)"
              formControlName="telephoneNumber" />
            <!-- ERROR -->
            @if (telephoneNumber.touched && telephoneNumber.invalid) {
              <mat-error id="telephoneNumberError">
                {{ telephoneNumber.errors | errorsFormatingAndTranslate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
      @if (controls.profession; as profession) {
        <div class="standard-form-field widened-field profession-field required-field">
          <label id="applicantProfessionLabel" [class.invalid]="profession.touched && profession.invalid">
            {{ 'PERSONAL_DATA_FORM.PROFESSION.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <mat-select
              [formControl]="profession"
              id="applicantProfession"
              aria-labelledby="applicantProfessionLabel"
              panelClass="standard-select"
              placeholder="{{ 'PERSONAL_DATA_FORM.PROFESSION.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="profession.touched && profession.invalid ? 'true' : null"
              [attr.aria-describedby]="profession.touched && profession.invalid ? 'professionError' : null">
              @for (item of professions; track item) {
                <mat-option [value]="item">
                  {{ 'COMMON.PROFESSIONS.' + item | translate }}
                </mat-option>
              }
            </mat-select>
            <!-- ERROR -->
            @if (profession.touched && profession.invalid) {
              <mat-error id="professionError">
                {{ profession.errors | errorsFormatingAndTranslate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
    </div>
    <div class="row">
      <div class="nowrap-container">
        @if (controls.descriptionHeight; as descriptionHeight) {
          <div class="standard-form-field descriptionHeight-field required-field">
            <label
              for="applicantDescriptionHeight"
              [class.invalid]="descriptionHeight.touched && descriptionHeight.invalid">
              {{ 'PERSONAL_DATA_FORM.DESCRIPTION-HEIGHT.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="applicantDescriptionHeight"
                type="number"
                inputmode="numeric"
                min="50"
                max="280"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-invalid]="descriptionHeight.touched && descriptionHeight.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  descriptionHeight.touched && descriptionHeight.invalid ? 'descriptionHeightError' : null
                "
                placeholder="{{ 'PERSONAL_DATA_FORM.DESCRIPTION-HEIGHT.PLACEHOLDER' | translate }}"
                [formControl]="descriptionHeight" />
              <!-- ERROR -->
              @if (descriptionHeight.touched && descriptionHeight.invalid) {
                <mat-error id="descriptionHeightError">
                  {{ descriptionHeight.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (controls.descriptionColourOfEyes; as descriptionColourOfEyes) {
          <div class="standard-form-field descriptionColourOfEyes-field required-field">
            <label
              id="applicantDescriptionColourOfEyesLabel"
              [class.invalid]="descriptionColourOfEyes.touched && descriptionColourOfEyes.invalid">
              {{ 'PERSONAL_DATA_FORM.DESCRIPTION-COLOUR-OF-EYES.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <mat-select
                [formControl]="descriptionColourOfEyes"
                id="applicantDescriptionColourOfEyes"
                aria-labelledby="applicantDescriptionColourOfEyesLabel"
                panelClass="standard-select"
                placeholder="{{ 'PERSONAL_DATA_FORM.DESCRIPTION-COLOUR-OF-EYES.PLACEHOLDER' | translate }}"
                [required]="false"
                [attr.aria-required]="false"
                [attr.aria-invalid]="descriptionColourOfEyes.touched && descriptionColourOfEyes.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  descriptionColourOfEyes.touched && descriptionColourOfEyes.invalid
                    ? 'descriptionColourOfEyesError'
                    : null
                ">
                @for (item of selectsValues.EYES; track item) {
                  <mat-option [value]="item.value">
                    {{ item.label }}
                  </mat-option>
                }
              </mat-select>
              <!-- ERROR -->
              @if (descriptionColourOfEyes.touched && descriptionColourOfEyes.invalid) {
                <mat-error id="descriptionColourOfEyesError">
                  {{ descriptionColourOfEyes.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
    </div>
    <div class="row">
      @if (controls.descriptionSpecialMarks; as descriptionSpecialMarks) {
        <div class="standard-form-field widened-field descriptionSpecialMarks-field">
          <label
            for="applicantDescriptionSpecialMarks"
            [class.invalid]="descriptionSpecialMarks.touched && descriptionSpecialMarks.invalid">
            {{ 'PERSONAL_DATA_FORM.DESCRIPTION-SPECIAL-MARKS.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantDescriptionSpecialMarks"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.DESCRIPTION-SPECIAL-MARKS.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-invalid]="descriptionSpecialMarks.touched && descriptionSpecialMarks.invalid ? 'true' : null"
              [attr.aria-describedby]="
                descriptionSpecialMarks.touched && descriptionSpecialMarks.invalid
                  ? 'descriptionSpecialMarksError'
                  : null
              "
              [formControl]="descriptionSpecialMarks" />
            <!-- ERROR -->
            @if (descriptionSpecialMarks.touched && descriptionSpecialMarks.invalid) {
              <mat-error id="descriptionSpecialMarksError">
                {{ descriptionSpecialMarks.errors | errorsFormatingAndTranslate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
    </div>
    <app-partial-residence-address
      [controls]="controls"
      [mode]="mode"
      [voivodeships$]="voivodeships$"
      [districts$]="districts$"
      [municips$]="municips$"
      [cities$]="cities$"
      [loadingDistricts$]="loadingDistricts$"
      [loadingMunicips$]="loadingMunicips$"
      [loadingCities$]="loadingCities$"
      [lookingForVoivodeship]="lookingForVoivodeship"
      [voivoIsBeeingUsed]="voivoIsBeeingUsed"
      [userACKDocumentsReset]="userACKDocumentsReset"
      [showDivider]="true"
      warningLayout="spaced"
      voivodeshipSpinnerClass="loading-wrapper"
      [voivodeshipSpinnerDiameter]="25"
      (voivoChangeAcknowledged)="voivoChangeACK()"
      (lastFieldTabPressed)="lastFieldTabPressed.emit()">
    </app-partial-residence-address>
    <app-partial-origin-country-address [controls]="controls"> </app-partial-origin-country-address>
  </div>
</form>
